import { Checkbox, Collapse } from 'antd';

const PlayerRegTermsDisplay = ({ terms, checked = [], onChange }) => {
  if (!terms || terms.length === 0) return <div>No terms to display.</div>;
  
  const collapseItems = terms.map((term, idx) => ({
    key: idx,
    label: 'View Terms',
    children: <div dangerouslySetInnerHTML={{ __html: term }} />
  }));

  return (
    <div className="flex flex-col gap-4">
      {terms.map((term, idx) => (
        <div key={idx}>
          <Checkbox
            className="mb-2"
            checked={checked[idx] || false}
            onChange={e => onChange && onChange(idx, e.target.checked)}
          >
            I agree to the following:
          </Checkbox>
          <Collapse 
            items={[collapseItems[idx]]}
            className="border p-2 rounded bg-gray-100"
            defaultActiveKey={[]} // All panels collapsed by default
            ghost
          />
        </div>
      ))}
    </div>
  );
};

export default PlayerRegTermsDisplay; 